/**
 * Liftgate delivery: PDP modal gate + cart sync ($150/order).
 * Config: window.MicrotecLiftgate (from Liquid).
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'microtec_liftgate_choice';
  var ATTR_CHOICE = 'liftgate_choice';
  var ATTR_RESIDENTIAL = 'Residential address';
  var PROP_DELIVERY = 'Shipping';
  var PROP_VAL_LIFTGATE = 'For residential addresses';
  var PROP_VAL_COMMERCIAL = 'Ships via freight';

  function cfg() {
    return window.MicrotecLiftgate || {};
  }

  function parseWeight(raw) {
    if (raw == null || raw === '') return 0;
    if (typeof raw === 'number') return raw;
    var s = String(raw)
      .replace(/,/g, '')
      .replace(/lbs?\.?/gi, '')
      .replace(/pounds?/gi, '')
      .trim();
    var n = parseFloat(s);
    return isNaN(n) ? 0 : n;
  }

  function money(cents) {
    try {
      if (window.themeCore && window.themeCore.utils && window.themeCore.utils.formatMoney) {
        return window.themeCore.utils.formatMoney(cents);
      }
    } catch (e) {}
    return '$' + (cents / 100).toFixed(2);
  }

  function getStoredChoice() {
    try {
      return sessionStorage.getItem(STORAGE_KEY) || '';
    } catch (e) {
      return '';
    }
  }

  function setStoredChoice(value) {
    try {
      if (value) sessionStorage.setItem(STORAGE_KEY, value);
      else sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {}
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) {
      return r.json();
    });
  }

  function updateCart(payload) {
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    }).then(function (r) {
      return r.json();
    });
  }

  function addToCart(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items }),
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) {
          var msg =
            (data && (data.description || data.message || data.status)) ||
            'Could not add liftgate to cart';
          throw new Error(typeof msg === 'string' ? msg : JSON.stringify(data));
        }
        return data;
      });
    });
  }

  /**
   * Prefer theme CartApi so drawer / count / notifications stay in sync.
   */
  function themeAddItems(items) {
    if (
      window.themeCore &&
      window.themeCore.CartApi &&
      typeof window.themeCore.CartApi.makeRequest === 'function'
    ) {
      var Api = window.themeCore.CartApi;
      var action = Api.actions.ADD_TO_CART_MANY || Api.actions.addItems || 'addItems';
      return Api.makeRequest(action, items).then(function () {
        var getAction = Api.actions.GET_CART || Api.actions.getCart || 'getCart';
        return Api.makeRequest(getAction).then(function (cart) {
          return cart || fetchCart();
        });
      });
    }
    return addToCart(items).then(function () {
      return fetchCart();
    });
  }

  /** Build a cart line item from a product form (id, qty, properties). */
  function formToCartItem(form) {
    if (!form) return null;
    var fd = new FormData(form);
    var id = Number(fd.get('id') || 0);
    if (!id) return null;
    var quantity = Number(fd.get('quantity') || 1) || 1;
    var properties = {};
    fd.forEach(function (value, key) {
      var m = String(key).match(/^properties\[([^\]]+)\]$/);
      if (m && value !== '' && value != null) {
        properties[m[1]] = value;
      }
    });
    var item = { id: id, quantity: quantity };
    if (Object.keys(properties).length) item.properties = properties;
    return item;
  }

  function setCartAttributes(choice) {
    var attrs = {};
    attrs[ATTR_CHOICE] = choice || '';
    if (choice === 'liftgate') attrs[ATTR_RESIDENTIAL] = 'Yes';
    if (choice === 'commercial') attrs[ATTR_RESIDENTIAL] = 'No';
    return updateCart({ attributes: attrs });
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) {
          throw new Error((data && data.description) || 'Cart change failed');
        }
        return data;
      });
    });
  }

  /**
   * Resolve liftgate variant id from config or product JSON by handle.
   */
  function resolveLiftgateVariantId() {
    var existing = liftgateVariantId();
    if (existing) return Promise.resolve(existing);

    var handle = (cfg().productHandle || 'liftgate-delivery').replace(/^\/+|\/+$/g, '');
    return fetch('/products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin',
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Liftgate product not found: /products/' + handle);
        return r.json();
      })
      .then(function (product) {
        if (!product || !product.variants || !product.variants.length) {
          throw new Error('Liftgate product has no variants');
        }
        var variant = product.variants[0];
        var id = Number(variant.id);
        window.MicrotecLiftgate = window.MicrotecLiftgate || {};
        window.MicrotecLiftgate.variantId = id;
        window.MicrotecLiftgate.productId = product.id;
        window.MicrotecLiftgate.productHandle = product.handle || handle;
        if (variant.available === false) {
          console.warn('[Liftgate] Variant reports available=false; add may still work if inventory is not tracked');
        }
        return id;
      });
  }

  function liftgateVariantId() {
    var c = cfg();
    return Number(c.variantId || 0) || 0;
  }

  function isLiftgateLine(item) {
    if (!item) return false;
    var vid = liftgateVariantId();
    if (vid && Number(item.variant_id) === vid) return true;

    var handle = String(item.handle || item.product_handle || '').toLowerCase();
    var expected = String(cfg().productHandle || 'liftgate-delivery').toLowerCase();
    if (handle && handle === expected) return true;

    var title = String(item.product_title || item.title || '').toLowerCase();
    if (title.indexOf('liftgate') !== -1) return true;

    // Product id map from Liquid if provided
    var liftProductId = Number(cfg().productId || 0);
    if (liftProductId && Number(item.product_id) === liftProductId) return true;

    return false;
  }

  function lineIsHeavy(item) {
    if (isLiftgateLine(item)) return false;
    var map = cfg().productWeights || {};
    var w = map[String(item.product_id)];
    if (w == null && item.product_id) w = map[item.product_id];
    if (w == null && item.grams) w = item.grams / 453.592;
    return parseWeight(w) >= (Number(cfg().threshold) || 120);
  }

  function cartHasHeavy(cart) {
    return (cart.items || []).some(lineIsHeavy);
  }

  function findLiftgateItems(cart) {
    return (cart.items || []).filter(isLiftgateLine);
  }

  function findLiftgateItem(cart) {
    var list = findLiftgateItems(cart);
    return list.length ? list[0] : null;
  }

  /**
   * Theme cart UI expects cart:updated with params (and optionally sections).
   * Without params the cart module can throw and skip re-render.
   */
  function emitCartUpdated(cart) {
    var payload = Object.assign({}, cart || {}, {
      cart: cart,
      cartState: cart,
      params: [{ noOpen: true }],
      sections: (cart && cart.sections) || undefined,
    });
    try {
      if (window.themeCore && window.themeCore.EventBus) {
        window.themeCore.EventBus.emit('cart:updated', payload);
        window.themeCore.EventBus.emit('cart:refresh', cart && cart.sections ? cart.sections : null);
      }
    } catch (e) {
      console.warn('[Liftgate] cart event emit failed', e);
    }
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: payload }));
  }

  function refreshCartUi(cart, options) {
    options = options || {};
    emitCartUpdated(cart);
    // Prefer theme cart refresh over full page reload (reload broke cart banner re-bind)
    try {
      if (
        window.themeCore &&
        window.themeCore.CartApi &&
        typeof window.themeCore.CartApi.makeRequest === 'function'
      ) {
        var getAction =
          window.themeCore.CartApi.actions.GET_CART ||
          window.themeCore.CartApi.actions.getCart ||
          'getCart';
        window.themeCore.CartApi.makeRequest(getAction, { noOpen: true }).catch(function () {});
      }
    } catch (e) {}
    // Soft re-bind banners after theme re-renders section HTML
    setTimeout(function () {
      if (window.MicrotecLiftgateApp && typeof window.MicrotecLiftgateApp.boot === 'function') {
        window.MicrotecLiftgateApp.boot();
      }
    }, 250);
    // Optional hard reload only when explicitly requested
    if (options.hardReload) {
      try {
        if (/\/cart\/?$/.test(window.location.pathname)) {
          window.location.reload();
        }
      } catch (e) {}
    }
  }

  /**
   * Ensure liftgate line is qty 1 if needed, else fully removed.
   * choice: 'liftgate' | 'commercial' | ''
   * options.force — when true, treat cart as needing liftgate even if weight map failed
   */
  function syncLiftgateLine(choice, options) {
    options = options || {};

    return resolveLiftgateVariantId()
      .catch(function (err) {
        console.warn('[Liftgate] variant resolve:', err && err.message ? err.message : err);
        return liftgateVariantId() || 0;
      })
      .then(function (resolvedVid) {
        return fetchCart().then(function (cart) {
          var heavy = cartHasHeavy(cart);
          var lifts = findLiftgateItems(cart);
          var lift = lifts[0] || null;
          // need liftgate line when:
          // - choice is liftgate AND cart has heavy items, OR
          // - force / fromCart / fromPdp (user made an explicit decision before the heavy product is in cart)
          var need =
            choice === 'liftgate' &&
            (heavy ||
              options.force === true ||
              options.fromCart === true ||
              options.fromPdp === true ||
              lifts.length > 0);
          // Commercial always clears
          if (choice === 'commercial') need = false;

          var vid = Number(resolvedVid) || (lift && lift.variant_id) || liftgateVariantId() || 0;

          if (lift && lift.variant_id) {
            window.MicrotecLiftgate = window.MicrotecLiftgate || {};
            window.MicrotecLiftgate.variantId = lift.variant_id;
            window.MicrotecLiftgate.productId = lift.product_id;
            vid = Number(lift.variant_id);
          }

          var attrs = Object.assign({}, cart.attributes || {});
          attrs[ATTR_CHOICE] = choice || '';
          if (choice === 'liftgate') attrs[ATTR_RESIDENTIAL] = 'Yes';
          if (choice === 'commercial') attrs[ATTR_RESIDENTIAL] = 'No';

          var updates = {};
          lifts.forEach(function (item) {
            updates[item.key] = 0;
          });

          var chain;

          if (need) {
            if (!lift) {
              if (!vid) {
                console.error('[Liftgate] No variant ID — create product handle "liftgate-delivery" or set MicrotecLiftgate.variantId');
                return updateCart({ attributes: attrs }).then(function (c) {
                  refreshCartUi(c);
                  throw new Error(
                    'Liftgate product not found. Create a product with handle “liftgate-delivery” priced at $150.'
                  );
                });
              }
              console.info('[Liftgate] Adding variant', vid);
              chain = themeAddItems([{ id: Number(vid), quantity: 1 }])
                .then(function (added) {
                  console.info('[Liftgate] Add response', added);
                  return updateCart({ attributes: attrs });
                })
                .catch(function (err) {
                  // Fallback if theme CartApi fails
                  console.warn('[Liftgate] themeAddItems failed, raw add', err);
                  return addToCart([{ id: Number(vid), quantity: 1 }]).then(function () {
                    return updateCart({ attributes: attrs });
                  });
                });
            } else {
              updates[lift.key] = 1;
              chain = updateCart({ updates: updates, attributes: attrs });
            }
          } else {
            if (Object.keys(updates).length) {
              chain = updateCart({ updates: updates, attributes: attrs });
            } else {
              chain = updateCart({ attributes: attrs });
            }
          }

          return chain
            .then(function (finalCart) {
              return fetchCart().then(function (fresh) {
                if (finalCart && finalCart.attributes) {
                  fresh.attributes = finalCart.attributes;
                }
                // Verify add succeeded when requested
                if (need && !findLiftgateItem(fresh)) {
                  console.error('[Liftgate] Fee line missing after add', {
                    vid: vid,
                    items: fresh.items,
                  });
                  throw new Error('Liftgate was not added to the cart. Check that the product is available for purchase.');
                }
                refreshCartUi(fresh);
                return fresh;
              });
            })
            .catch(function (err) {
              console.error('[Liftgate] sync failed', err);
              if (choice === 'commercial' || !need) {
                var removeChain = Promise.resolve();
                lifts.forEach(function (item) {
                  removeChain = removeChain.then(function () {
                    return changeLine(item.key, 0);
                  });
                });
                return removeChain
                  .then(function () {
                    return updateCart({ attributes: attrs });
                  })
                  .then(function (c) {
                    refreshCartUi(c);
                    return c;
                  });
              }
              throw err;
            });
        });
      });
  }

  /* ---------- PDP ---------- */

  function initPdp(root) {
    if (!root || root.getAttribute('data-liftgate-eligible') !== 'true') return;
    if (root.getAttribute('data-liftgate-pdp-bound') === 'true') return;
    root.setAttribute('data-liftgate-pdp-bound', 'true');

    var modal = root.querySelector('[data-liftgate-modal]');
    var openBtns = root.querySelectorAll('[data-liftgate-open]');
    var closeBtns = root.querySelectorAll('[data-liftgate-close]');
    var commercialBtn = root.querySelector('[data-liftgate-choose="commercial"]');
    var liftgateBtn = root.querySelector('[data-liftgate-choose="liftgate"]');
    var statusEl = root.querySelector('[data-liftgate-status]');
    var requireChoice = root.getAttribute('data-require-choice') !== 'false';
    var pendingSubmit = null;
    var isSubmitting = false;
    var ensuring = false;
    var choice = getStoredChoice() || root.getAttribute('data-initial-choice') || '';

    function updateStatus() {
      if (!statusEl) return;
      if (choice === 'liftgate') {
        statusEl.hidden = false;
        statusEl.textContent =
          root.getAttribute('data-status-liftgate') ||
          'Liftgate service selected (+$150 per order).';
        statusEl.setAttribute('data-state', 'liftgate');
      } else if (choice === 'commercial') {
        statusEl.hidden = false;
        statusEl.textContent =
          root.getAttribute('data-status-commercial') ||
          'Commercial delivery (no liftgate).';
        statusEl.setAttribute('data-state', 'commercial');
      } else {
        statusEl.hidden = true;
        statusEl.textContent = '';
      }
    }

    function openModal() {
      if (!modal) return;
      modal.hidden = false;
      modal.removeAttribute('hidden');
      document.body.classList.add('liftgate-modal-open');
      var focusable = modal.querySelector('button, [href], input');
      if (focusable) focusable.focus();
    }

    function closeModal() {
      if (!modal) return;
      modal.hidden = true;
      modal.setAttribute('hidden', 'hidden');
      document.body.classList.remove('liftgate-modal-open');
    }

    function setPropertyInputs(form, value) {
      if (!form) return;
      var existing = form.querySelectorAll('[data-liftgate-property]');
      for (var i = 0; i < existing.length; i++) existing[i].remove();
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + PROP_DELIVERY + ']';
      input.value = value;
      input.setAttribute('data-liftgate-property', 'true');
      form.appendChild(input);
    }

    function setFormLoading(form, loading) {
      if (!form) return;
      var btns = form.querySelectorAll('[type="submit"], .js-product-add-to-cart-button, button[name="add"]');
      for (var i = 0; i < btns.length; i++) {
        if (loading) {
          btns[i].classList.add('loading');
          btns[i].setAttribute('aria-busy', 'true');
        } else {
          btns[i].classList.remove('loading');
          btns[i].removeAttribute('aria-busy');
        }
      }
    }

    /**
     * Add the PDP product (+ liftgate fee when chosen) via theme CartApi.
     * Avoids fragile preventDefault → re-submit races with the theme handler.
     */
    function addProductAndLiftgate(form) {
      var productItem = formToCartItem(form);
      if (!productItem) {
        return Promise.reject(new Error('Could not read product variant from the form.'));
      }

      var propVal =
        choice === 'liftgate'
          ? root.getAttribute('data-prop-liftgate') || PROP_VAL_LIFTGATE
          : root.getAttribute('data-prop-commercial') || PROP_VAL_COMMERCIAL;
      productItem.properties = productItem.properties || {};
      productItem.properties[PROP_DELIVERY] = propVal;

      return resolveLiftgateVariantId()
        .catch(function (err) {
          console.warn('[Liftgate] variant resolve:', err && err.message ? err.message : err);
          return liftgateVariantId() || 0;
        })
        .then(function (vid) {
          return fetchCart().then(function (cart) {
            var items = [productItem];
            var alreadyHasLift = !!findLiftgateItem(cart);

            if (choice === 'liftgate') {
              if (!alreadyHasLift) {
                if (!vid) {
                  throw new Error(
                    'Liftgate product not found. Create a product with handle “liftgate-delivery” priced at $150 and publish it to the Online Store.'
                  );
                }
                items.push({ id: Number(vid), quantity: 1 });
                console.info('[Liftgate] Adding product + liftgate together', items);
              } else {
                console.info('[Liftgate] Liftgate already in cart; adding product only');
              }
            }

            return themeAddItems(items).then(function (updatedCart) {
              // Commercial: strip any existing liftgate fee line
              var afterAdd =
                choice === 'commercial'
                  ? syncLiftgateLine('commercial', { fromPdp: true })
                  : setCartAttributes(choice).then(function () {
                      return updatedCart || fetchCart();
                    });
              return afterAdd.then(function (cart) {
                return cart || fetchCart();
              });
            });
          });
        });
    }

    /**
     * Safety net: after any cart change, ensure fee line matches the stored choice.
     */
    function ensureLiftgateInCart(cartHint) {
      if (ensuring || isSubmitting) return Promise.resolve(cartHint);
      var stored = getStoredChoice() || choice;
      if (stored !== 'liftgate' && stored !== 'commercial') return Promise.resolve(cartHint);

      ensuring = true;
      var load = cartHint && Array.isArray(cartHint.items) ? Promise.resolve(cartHint) : fetchCart();
      return load
        .then(function (cart) {
          if (!cart || !(cart.items || []).length) return cart;
          var hasLift = !!findLiftgateItem(cart);
          var heavy = cartHasHeavy(cart);
          // Add fee if missing and (heavy freight in cart OR user chose liftgate on this eligible PDP)
          if (stored === 'liftgate' && !hasLift && (heavy || root.getAttribute('data-liftgate-eligible') === 'true')) {
            return syncLiftgateLine('liftgate', { force: true, fromPdp: true });
          }
          if (stored === 'commercial' && hasLift) {
            return syncLiftgateLine('commercial', { fromPdp: true });
          }
          return cart;
        })
        .finally(function () {
          ensuring = false;
        });
    }

    function applyChoice(next, form) {
      choice = next;
      setStoredChoice(next);
      updateStatus();
      closeModal();

      var propVal =
        next === 'liftgate'
          ? root.getAttribute('data-prop-liftgate') || PROP_VAL_LIFTGATE
          : root.getAttribute('data-prop-commercial') || PROP_VAL_COMMERCIAL;

      if (form) setPropertyInputs(form, propVal);
      // Also attach properties to any product form on the page
      document.querySelectorAll('[data-js-product-form], form[action*="/cart/add"]').forEach(function (f) {
        setPropertyInputs(f, propVal);
      });

      // If ATC was waiting on the modal, complete it now
      if (pendingSubmit && pendingSubmit.form) {
        var formToSubmit = pendingSubmit.form;
        pendingSubmit = null;
        return submitWithLiftgate(formToSubmit);
      }

      // Choosing liftgate alone: only set attributes until they add the product
      // (fee is added with the product on ATC). Commercial: clear fee if present.
      if (next === 'commercial') {
        return syncLiftgateLine('commercial', { fromPdp: true }).catch(function (err) {
          console.warn('[Liftgate] commercial clear:', err);
        });
      }
      return setCartAttributes(next).catch(function () {});
    }

    function submitWithLiftgate(form) {
      if (isSubmitting) return Promise.resolve();
      isSubmitting = true;
      setFormLoading(form, true);
      return addProductAndLiftgate(form)
        .then(function (cart) {
          console.info('[Liftgate] PDP add complete', cart && cart.item_count);
          // Theme may already emit cart:updated via CartApi; refresh as backup
          refreshCartUi(cart);
          return cart;
        })
        .catch(function (err) {
          console.error('[Liftgate] PDP add failed', err);
          alert(
            (err && err.message) ||
              'Could not add liftgate service with this product. Please try again.'
          );
          throw err;
        })
        .finally(function () {
          isSubmitting = false;
          setFormLoading(form, false);
        });
    }

    openBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openModal();
      });
    });

    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        closeModal();
        pendingSubmit = null;
      });
    });

    if (modal) {
      modal.addEventListener('click', function (e) {
        if (e.target === modal) {
          closeModal();
          pendingSubmit = null;
        }
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && !modal.hidden) {
        closeModal();
        pendingSubmit = null;
      }
    });

    if (commercialBtn) {
      commercialBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var form = pendingSubmit && pendingSubmit.form;
        applyChoice('commercial', form);
      });
    }

    if (liftgateBtn) {
      liftgateBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var form = pendingSubmit && pendingSubmit.form;
        applyChoice('liftgate', form);
      });
    }

    // Capture-phase intercept: fully own ATC so product + liftgate add together
    document.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        if (!form || !form.matches || !form.matches('[data-js-product-form], form[action*="/cart/add"]')) {
          return;
        }
        // Only gate eligible heavy-product forms on this page
        if (isSubmitting) {
          e.preventDefault();
          e.stopPropagation();
          return;
        }

        if (!requireChoice) return;

        if (choice !== 'commercial' && choice !== 'liftgate') {
          e.preventDefault();
          e.stopPropagation();
          pendingSubmit = { form: form };
          openModal();
          return;
        }

        // Take over: add product (+ liftgate) via CartApi, skip theme form handler
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

        var propVal =
          choice === 'liftgate'
            ? root.getAttribute('data-prop-liftgate') || PROP_VAL_LIFTGATE
            : root.getAttribute('data-prop-commercial') || PROP_VAL_COMMERCIAL;
        setPropertyInputs(form, propVal);
        submitWithLiftgate(form);
      },
      true
    );

    // Dynamic checkout / buy it now clicks
    document.addEventListener(
      'click',
      function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        var buy =
          t.closest('[data-shopify="payment-button"] button') ||
          t.closest('.shopify-payment-button__button') ||
          t.closest('[name="checkout"]');
        if (!buy) return;
        if (!requireChoice) return;
        if (choice === 'commercial' || choice === 'liftgate') return;
        e.preventDefault();
        e.stopPropagation();
        pendingSubmit = null;
        openModal();
      },
      true
    );

    updateStatus();

    // If cart already has choice attribute, prefer it
    fetchCart()
      .then(function (cart) {
        var a = (cart.attributes && cart.attributes[ATTR_CHOICE]) || '';
        if (a === 'liftgate' || a === 'commercial') {
          choice = a;
          setStoredChoice(a);
          updateStatus();
        }
        return ensureLiftgateInCart(cart);
      })
      .catch(function () {});

    // After theme cart updates, re-check fee line is present
    if (window.themeCore && window.themeCore.EventBus) {
      window.themeCore.EventBus.listen('cart:updated', function (payload) {
        var cart = payload;
        if (payload && payload.items) cart = payload;
        else if (payload && payload.cart) cart = payload.cart;
        // Delay slightly so GET_CART can finish after ADD_TO_CART
        setTimeout(function () {
          ensureLiftgateInCart(cart && cart.items ? cart : null).catch(function (err) {
            console.warn('[Liftgate] ensure after cart:updated failed', err);
          });
        }, 150);
      });
    }
  }

  /* ---------- Cart banner ---------- */

  var cartBannerBusBound = false;

  function initCartBanner(root) {
    if (!root) return;
    // Re-bind if node was re-rendered (theme cart section replace)
    if (root.getAttribute('data-liftgate-cart-bound') === 'true') {
      // Still refresh visibility for existing root
      return;
    }
    root.setAttribute('data-liftgate-cart-bound', 'true');

    var commercialBtn = root.querySelector('[data-liftgate-cart="commercial"]');
    var liftgateBtn = root.querySelector('[data-liftgate-cart="liftgate"]');
    var residentialYes = root.querySelector('[data-liftgate-residential="yes"]');
    var residentialNo = root.querySelector('[data-liftgate-residential="no"]');
    var pendingChoice = null;
    var busy = false;

    // Unique radio group per banner (cart page + drawer can both be in the DOM)
    var radioGroup =
      'liftgate-residential-' + Math.random().toString(36).slice(2, 10);
    if (residentialYes) residentialYes.name = radioGroup;
    if (residentialNo) residentialNo.name = radioGroup;

    function syncRadios(choice) {
      if (residentialYes) residentialYes.checked = choice === 'liftgate';
      if (residentialNo) residentialNo.checked = choice === 'commercial';
    }

    function refreshVisibility(cart) {
      if (!root.isConnected) return;
      cart = cart || {};
      var items = cart.items || [];
      var heavy =
        cartHasHeavy(cart) || root.getAttribute('data-liquid-heavy') === 'true';
      // If Liquid said heavy and cart still has non-liftgate lines, keep trusting that
      if (!heavy && root.getAttribute('data-liquid-heavy') === 'true') {
        heavy = items.some(function (item) {
          return !isLiftgateLine(item);
        });
      }
      var choice =
        (cart.attributes && cart.attributes[ATTR_CHOICE]) || getStoredChoice() || '';
      var lift = findLiftgateItem(cart);
      // Show when freight needs a decision — hide once liftgate product is in cart
      var show = items.length > 0 && heavy && !lift;
      if (show) {
        root.hidden = false;
        root.removeAttribute('hidden');
      } else {
        root.hidden = true;
        root.setAttribute('hidden', 'hidden');
      }
      root.setAttribute('data-has-liftgate-line', lift ? 'true' : 'false');
      if (!show) return;

      root.setAttribute('data-choice', choice || 'none');
      if (choice === 'liftgate' || choice === 'commercial') {
        syncRadios(choice);
      }

      var msg = root.querySelector('[data-liftgate-cart-message]');
      if (msg) {
        if (choice === 'commercial') {
          msg.textContent =
            root.getAttribute('data-msg-commercial') ||
            'Commercial delivery selected (no liftgate fee).';
        } else {
          msg.textContent =
            root.getAttribute('data-msg-prompt') ||
            'Heavy equipment shipping: residential addresses or locations without a forklift usually need liftgate service (+$150 per order).';
        }
      }
    }

    /**
     * Radios and buttons share this path: add or remove the liftgate product.
     */
    function onChoose(choice) {
      if (choice !== 'liftgate' && choice !== 'commercial') return;
      if (busy) return;

      busy = true;
      pendingChoice = choice;
      setStoredChoice(choice);
      syncRadios(choice);
      root.classList.add('is-loading');

      console.info('[Liftgate] cart banner choice', choice);

      // fromCart + force: always honor explicit cart decision even if weight map is incomplete
      // syncLiftgateLine already emits cart:updated / soft UI refresh
      syncLiftgateLine(choice, { fromCart: true, force: choice === 'liftgate' })
        .then(function (cart) {
          console.info('[Liftgate] cart banner sync ok', cart && cart.item_count);
          if (cart) refreshVisibility(cart);
          else return fetchCart().then(refreshVisibility);
        })
        .catch(function (err) {
          console.error('[Liftgate] cart choice failed', err);
          alert(
            (err && err.message) ||
              'Could not update liftgate service. Please try again, or add “Liftgate delivery” from the product page.'
          );
        })
        .finally(function () {
          busy = false;
          pendingChoice = null;
          root.classList.remove('is-loading');
          // Re-bind any banners re-injected by the theme after cart HTML refresh
          setTimeout(bootCartBanners, 300);
        });
    }

    if (commercialBtn) {
      commercialBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        onChoose('commercial');
      });
    }
    if (liftgateBtn) {
      liftgateBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        onChoose('liftgate');
      });
    }

    function choiceFromRadio(input) {
      if (!input) return '';
      var val = input.getAttribute('data-liftgate-residential') || input.value;
      if (val === 'yes' || val === 'liftgate') return 'liftgate';
      if (val === 'no' || val === 'commercial') return 'commercial';
      return '';
    }

    root.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || t.type !== 'radio') return;
      if (!t.matches || !t.matches('[data-liftgate-residential]')) return;
      if (!t.checked) return;
      var c = choiceFromRadio(t);
      if (c) onChoose(c);
    });

    // Initial paint — keep visible until we know liftgate is present
    root.hidden = false;
    fetchCart()
      .then(refreshVisibility)
      .catch(function () {
        // Keep Liquid-rendered banner visible if cart.js fails
        if (root.getAttribute('data-liquid-heavy') === 'true') {
          root.hidden = false;
        }
      });
  }

  function bindCartBannerBus() {
    if (cartBannerBusBound) return;
    cartBannerBusBound = true;

    function onCartEvent(payload) {
      var cart = null;
      if (payload && Array.isArray(payload.items)) cart = payload;
      else if (payload && payload.cart && Array.isArray(payload.cart.items)) cart = payload.cart;
      else if (payload && payload.cartState && Array.isArray(payload.cartState.items))
        cart = payload.cartState;

      // Re-bind any newly injected banners (drawer section re-render)
      setTimeout(function () {
        bootCartBanners();
        if (cart) {
          document.querySelectorAll('[data-liftgate-cart-root]').forEach(function (root) {
            // force visibility pass via fresh cart if handlers already bound
            if (root._liftgateRefresh) root._liftgateRefresh(cart);
          });
        } else {
          fetchCart()
            .then(function (fresh) {
              document.querySelectorAll('[data-liftgate-cart-root]').forEach(function (root) {
                if (root._liftgateRefresh) root._liftgateRefresh(fresh);
              });
            })
            .catch(function () {});
        }
      }, 100);
    }

    if (window.themeCore && window.themeCore.EventBus) {
      window.themeCore.EventBus.listen('cart:updated', onCartEvent);
      window.themeCore.EventBus.listen('cart:refresh', function () {
        onCartEvent(null);
      });
    }
    document.addEventListener('cart:updated', function (e) {
      onCartEvent((e && e.detail) || null);
    });
  }

  function bootCartBanners() {
    document.querySelectorAll('[data-liftgate-cart-root]').forEach(function (root) {
      // If node was replaced, bound attr is gone — init binds fresh listeners
      initCartBanner(root);
      // Expose refresh for bus
      if (!root._liftgateRefresh) {
        root._liftgateRefresh = function (cart) {
          var heavy =
            cartHasHeavy(cart) || root.getAttribute('data-liquid-heavy') === 'true';
          var lift = findLiftgateItem(cart);
          var items = (cart && cart.items) || [];
          var show = items.length > 0 && heavy && !lift;
          root.hidden = !show;
          if (!show) root.setAttribute('hidden', 'hidden');
          else root.removeAttribute('hidden');
        };
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-liftgate-root]').forEach(initPdp);
    bootCartBanners();
    bindCartBannerBus();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Expose for debugging / re-init after section reload
  window.MicrotecLiftgateApp = {
    syncLiftgateLine: syncLiftgateLine,
    boot: boot,
    bootCartBanners: bootCartBanners,
  };
})();

